const getDefaultState = () => {
  return {
    highlighting: false,
    highlightsCount: 0,
    highlightsCurrent: -1,
    show: true,
    hideReminders: true,
    helper: {
      title: null,
      post_type: [],
      full_title: null,
      base_id: null,
      locked: false,
      similar: [],
      also_read: [],
      related: [],
      ///////////
    },
  };
};
const state = getDefaultState;

const getters = {
  getHighlightState: (state) => {
    return state.highlighting;
  },
  getHighlightsCount: (state) => {
    return state.highlightsCount;
  },
  getHighlightsIndex: (state) => {
    return state.highlightsCurrent;
  },
  getHelperData: (state) => {
    return state.helper;
  },
  getHelperRemindersHideState: (state) => {
    return state.hideReminders;
  },
  getHelperTitle: (state) => {
    return state.helper.title;
  },
  getHelperContents: (state) => {
    return state.helper.contents || false;
  },
  getHelperImages: (state) => {
    return state.helper.images || false;
  },
  getHelperLinks: (state) => {
    return state.helper.links || false;
  },
  getHelperDynamedLinks: (state) => {
    return state.helper.dynamedLinks || false;
  },
};

const mutations = {
  resetHelpState(state) {
    Object.assign(state, getDefaultState());
  },
  toggleHelpRemindersHideState(state) {
    state.hideReminders = !state.hideReminders;
  },
  updateHighlightIndex(state, index) {
    state.highlightsCurrent = index;
  },
  updateHighlightCount(state, count) {
    state.highlightsCount = count;
  },
  hideHelpRemindersHideState(state) {
    state.hideReminders = true;
  },
  setHelperData: (state, helperData) => {
    const modalParams = Object.keys(helperData);
    modalParams.forEach((key) => (state.helper[key] = helperData[key]));
  },
};

const actions = {
  resetHelperData({ commit }) {
    commit("resetHelpState");
  },
  toggleHelperRemindersState({ commit }) {
    commit("toggleHelpRemindersHideState");
  },
  hideHelperRemindersState({ commit }) {
    commit("hideHelpRemindersHideState");
  },
  setHelperData({ commit }, helperData) {
    commit("setHelperData", helperData);
  },
  setHighlightIndex({ commit }, index) {
    commit("updateHighlightIndex", index);
  },
  setHighlightCount({ commit }, count) {
    commit("updateHighlightCount", count);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
